// @flow
import React, { forwardRef } from 'react';
import Recaptcha from 'react-google-recaptcha';
import useFeature from '../../hooks/useFeature';

declare var __CYPRESS__: boolean;

const debug = require('debug')('jp:captcha');

type Props = {
  size: string,
  badge: string,
  onChange: any => void,
  style?: {}
};

type NullProps = {
  onChange: any => void
};

class NullRecaptcha extends React.Component<NullProps> {
  // eslint-disable-next-line class-methods-use-this
  reset() {}

  execute() {
    const { onChange } = this.props;
    onChange('null_recaptcha_token');
  }

  render() {
    return null;
  }
}

const Captcha = forwardRef(
  ({ size, badge, onChange, style = {} }: Props, ref) => {
    const skipCaptcha = __CYPRESS__;
    const useV2 = useFeature('google_recaptcha_use_v2');
    const siteKey = useV2
      ? process.env.RECAPTCHA_KEY_V2
      : process.env.RECAPTCHA_KEY;

    debug(`Using v${useV2 ? '2' : '3'} captcha ${siteKey}`);
    debug('Skip', skipCaptcha);

    return skipCaptcha ? (
      <NullRecaptcha ref={ref} onChange={onChange} />
    ) : (
      <Recaptcha
        size={size}
        badge={badge}
        sitekey={siteKey || ''}
        onChange={onChange}
        ref={ref}
        style={style}
      />
    );
  }
);

export default Captcha;
